<template>
  <div id="app">
    <!-- <pre class="result">{{ value }}</pre> -->
    <treeselect 
    :open-on-click="openOnClick" 
    :options="options" 
    :disable-branch-nodes="disableBranchBodes" 
    :show-count="true" 
    :multiple="multiple" 
    :disabled="disabled" 
    :append-to-body="appendToBody" 
    :searchable="searchable" 
    @select="nodeSelect" 
    @input="inputclear"
    :default-expand-level="0"
    :placeholder="placeholder"
    :always-open="alwaysOpen"
     v-model="value"
     >
  <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
  <Icon type="md-folder" color="#ffcb0f" size="16" :style="{display:showIcon?'inline':'none'}" /> {{ node.label }} 
  </label>
   </treeselect>
  </div>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import opData from '../../../static/api/select-tree2.json'
export default {
  // register the component
  name: 'Tree-Single-Select',
  props: {
    tData: Object,
    // isDisabled: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  components: { Treeselect },
  data() {
    return {
      value: null,
      options:this.tData===undefined?[]:this.tData.data,//this.getTreeData(),
      treeMultiple: true,
      openOnClick: true,
      multiple: false,
      disabled:false,//this.isDisabled?true:false,
      appendToBody: false,
      disableBranchBodes: false,
      searchable: false,
      placeholder:"请选择文件效力",
      showIcon:false,
      alwaysOpen:false,
    }
  },
  methods: {
    setValue(val){
      this.value=val
    },
    setDisabled(value){
      this.disabled=value
    },
    getTreeData() {
      //console.log("json:"+this.tData.data)
      return this.tData.data
      //return opData
    },
    nodeSelect(node) {
      this.$emit('tag-Select', node)
    },
    inputclear(value){
      //console.log(value)
      if(value===undefined){
        this.$emit('onClearText')
      }
    },
    bindData(node) {
      //console.log(node)
      this.options = node.data
      this.placeholder=node.placeholder
      this.searchable=node.searchable
      this.showIcon=node.showIcon===undefined?false:node.showIcon
    },
    bindDataTag(node) {
      //console.log(node)
      this.options = node
      // this.placeholder=node.placeholder
      // this.searchable=node.searchable
    },
    setShowValue(value){
      console.log("value:"+value)
      this.value=value
    },

  },
   mounted(){
    // console.log("child mounted")
    // console.log(this.tData.data)
    // this.options = this.tData.data
  },
  watch: {
    // tData:{
    //   handler:function(val,oldVal){
    //     this.options=val
    //   }
    // }
    // multiple(newValue) {
    //   if (newValue) {
    //     this.value = this.value ? [ this.value ] : []
    //   } else {
    //     this.value = this.value[0]
    //   }
    // },
  },

}

</script>
